var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m0 0h28v28h-28z","fill":"none","key":0}),React.createElement("path",{"className":"path","d":"m12.54 21.58a.88.88 0 0 1 0-1.75h12.25a.88.88 0 1 1 0 1.75zm-9.33-7a.88.88 0 1 1 0-1.75h21.58a.88.88 0 1 1 0 1.75zm0-7a.88.88 0 1 1 0-1.75h12.25a.88.88 0 0 1 0 1.75z","fill":"#fff","key":1})]);
}

Menu.defaultProps = {"viewBox":"0 0 28 28"};

module.exports = Menu;

Menu.default = Menu;
